import { Editor } from "@tinymce/tinymce-react";

const FormEditor = ({ defaultValue, onEditorChange }) => {
  return (
    <Editor
      apiKey={process.env.REACT_APP_TMCE_KEY}
      onInit={(evt, editor) => {
        editor.getContent({ format: "text" });
      }}
      value={defaultValue}
      init={{
        height: 200,
        menubar: false,
        plugins: [
          "advlist",
          "autolink",
          "lists",
          "link",
          "image",
          "charmap",
          "preview",
          "anchor",
          "searchreplace",
          "visualblocks",
          "code",
          "fullscreen",
          "insertdatetime",
          "media",
          "table",
          "code",
          "help",
          "wordcount",
        ],
        toolbar:
          "undo redo | blocks | " +
          "bold italic forecolor | alignleft aligncenter " +
          "alignright alignjustify | bullist numlist outdent indent | " +
          "removeformat | help",
        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        // content_css: './scss/_general.scss'
      }}
      outputFormat="text"
      onEditorChange={onEditorChange}
    />
  );
};

FormEditor.defaultProps = {
  onEditorChange: () => {},
};

export default FormEditor;
